<ng-container *ngrxLet="progressInfo$ as progressInfo">
    <div class="modal-header" id="initialization-progress-modal-title">
        <h3 class="modal-title" id="modal-title">Initializing {{ applicationName }}</h3>
    </div>
    <div class="modal-body" id="modal-body">
        <div class="container-fluid d-flex p-0 progress-stepper">
            @for (message of progressInfo.progress; track message; let messageIndex = $index) {
                <div class="position-relative w-100 loading-indicator">
                    <div
                        class="position-relative start-0 top-0 rounded-circle indicator-circle"
                        [title]="message.description | async"
                        [ngClass]="{
                            success: message.state === 'Success',
                            warning: message.state === 'Warning',
                            danger: message.state === 'Error',
                            pending: message.state === 'Pending',
                            added: message.state === 'Added',
                        }"
                    ></div>
                    @if (messageIndex !== progressInfo.progress.length - 1) {
                        <div
                            class="position-absolute start-0 w-100 indicator-connector"
                            [ngClass]="{
                                success: message.state === 'Success',
                                warning: message.state === 'Warning',
                                hidden: message.state === 'Error',
                                pending: message.state === 'Pending',
                                added: message.state === 'Added',
                            }"
                        ></div>
                    }
                </div>
            }
        </div>
        <div class="text-center m-3 pt-5">
            @if (!progressInfo.isInitError) {
                <h6>
                    {{ progressInfo.currentMessage?.description | async }}
                </h6>
            } @else {
                <div class="d-flex justify-content-center align-items-baseline">
                    <span class="h4">Something went wrong.</span>
                    <button type="button" class="btn btn-link" (click)="toggleErrors()">Details</button>
                </div>
            }
        </div>
        <div [collapse]="isErrorCollapsed" [isAnimated]="true">
            @for (message of progressInfo.errorList; track message) {
                <dl class="row">
                    <dt class="text-danger col-12">{{ message.key | uppercase }}</dt>
                    <dd class="text-danger col-12">{{ message.description | async }}</dd>
                </dl>
            }
        </div>
    </div>
    <div
        class="modal-footer d-flex"
        [ngClass]="progressInfo.isInitError ? 'justify-content-around' : 'justify-content-end'"
    >
        @if (progressInfo.isInitError) {
            <button type="button" class="btn btn-primary" (click)="tryAgain()">
                {{ 'APP_START_TRY_AGAIN' | translate }}
            </button>
        }
        <button type="button" class="btn btn-primary" (click)="openReportIssue()">
            {{ 'APP_START_REPORT_ISSUE' | translate }}
        </button>
    </div>
    <div class="text-end p-2 fw-bold">
        <div>Version: {{ currentAppVersion }}</div>
        <div>Backend: {{ currentBackend }}</div>
    </div>
</ng-container>
